/**
 * Pages a consent popup lands on: tenant-less (reserved slugs, so no tenant
 * can own them) and session-less — they say how the consent ended and close.
 * Under `/<tenant>/` the popup would meet the login gate instead.
 *
 *   /google-access     Google's consent (modules/cloud-storage/paths.ts)
 *   /monday-connected  "Connect monday.com" for White-Label → Support
 *   /connector-connected  a person's own sign-in to a connector (item 65A)
 */

import { isGoogleAccessPath } from '@/modules/cloud-storage/paths';

export const MONDAY_CONNECTED_PATH = '/monday-connected';

export function isMondayConnectedPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === MONDAY_CONNECTED_PATH;
}

export const CONNECTOR_CONNECTED_PATH = '/connector-connected';

export function isConnectorConnectedPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === CONNECTOR_CONNECTED_PATH;
}

/** A popup's landing page: kept at the root of app space, no chrome. */
export function isPopupLandingPath(pathname: string): boolean {
  return isGoogleAccessPath(pathname) || isMondayConnectedPath(pathname) || isConnectorConnectedPath(pathname);
}
